import type { ThemeConfig } from "antd";

// ProcureX consolidated theme — see docs/pms-design-system.md.
// Single primary #2557d6 (DashLite $accent-color); replaces antd's default #1677ff.
export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: "#2557d6",
    colorInfo: "#2557d6",
    colorLink: "#2557d6",
    fontFamily: "Inter, Roboto, sans-serif",
    borderRadius: 4,
    colorText: "#364a63",
    colorTextSecondary: "#526484",
    colorTextTertiary: "#8094ae",
    colorBorder: "#dbdfea",
  },
};

export default antdTheme;
